import { Form, Formik } from "formik";
import { useContext } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
import FormInput from "../../../components/FormInput";
import { AuthContext } from "../../../contexts/AuthContext";
import { validationSchema } from "./verify-otp-page.validation";
import { Spinner } from "reactstrap";
import OTPInput from "react-otp-input";

export default function VerifyOtpPage() {
  const { handleVerifyOtp } = useContext(AuthContext);

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    try {
      await handleVerifyOtp(values);
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      style={{
        backgroundColor: "white",
        backgroundImage:
          "url('https://d3fgk2078as9ko.cloudfront.net/assets/login.jpg')",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="ec-page-content section-space-p"
    >
      <div className="container">
        <div className="row">
          <div
            className="ec-login-wrapper"
            style={{
              maxWidth: "430px",
            }}
          >
            <div className="ec-login-container">
              <div className="account_form">
                <div className="text-center">
                  <img width="100px" src={Logo} />
                </div>
                <div className="text-center">
                  <h3>Welcome to</h3>
                  <h3
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Prince Art Exporter
                  </h3>
                  <h5>One Of A Kind Store</h5>
                </div>
              </div>
              <div className="ec-login-form">
                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    otp: "",
                  }}
                  onSubmit={handleSubmit}
                >
                  {({
                    handleChange,
                    handleBlur,
                    errors,
                    values,
                    touched,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <Form>
                      <OTPInput
                        value={values.otp}
                        onChange={(otp) => {
                          setFieldValue("otp", otp);
                        }}
                        numInputs={4}
                        renderSeparator={<span>-</span>}
                        containerStyle={{
                          justifyContent: "space-between",
                          margin: "20px 0",
                        }}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="form-control"
                            style={{
                              width: "50px",
                              height: "50px",
                              fontSize: "20px",
                              textAlign: "center",
                              borderRadius: "5px",
                            }}
                          />
                        )}
                      />

                      <div className="login_submit">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Verify OTP"
                          )}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
